var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 127.5",
    style: {
      enableBackground: "new 0 0 500 127.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#357D57;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.0319,
    y1: 89.5975,
    x2: 120.4482,
    y2: 22.9619
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5CC9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3186,
    style: {
      stopColor: "#E7CC98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#EBCB92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    style: {
      stopColor: "#D1AF7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    style: {
      stopColor: "#B79463"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#A78455"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A27E50"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.7,0c2.1,0.6,4.4,0.3,6.6,0.6C84.4,2.3,96,7.4,105.9,16.1c10.6,9.3,17.2,20.9,20.2,34.6 c1.2,5.6,1.4,11.2,1.2,16.9c-0.1,2.3,0.2,2.5,2.5,2.7c5.8,0.3,11.7,0.7,17.5,1c0.5,0,1-0.1,1.5,0.7C113.1,78.5,78,87.4,42.9,96.6 c19.4-23.2,38.3-46.8,56.9-70.8c-4.1,0-63.3,12.6-68.8,14.7c15.9-0.5,31.5-1.9,47.1-3.2c0.3,0.7-0.2,1-0.5,1.2 C67.6,49,58,59.9,48.4,70.7c-10,11.4-20,22.9-29.8,34.5c-1.4,1.7-1.7,1.7-3.1,0C6.5,94.9,1.3,82.8,0.2,69.2 c-1.3-17.1,3.3-32.5,14.3-45.8c10.5-12.7,24-20.2,40.3-22.7c2.6-0.4,5.2-0.5,7.9-0.8C63.4,0,64,0,64.7,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500,98.1c-3.7,0-7.4,0-11.1,0.1c-1.1,0-1.6-0.4-1.6-1.5c0.1-1.4,0-2.8,0-4.7c-3,3.6-6.6,5.6-10.8,6.3 c-7.1,1.3-14,1.1-20.3-3c-5.1-3.3-7.6-8.2-7.2-14.3c0.5-6.8,4.2-11.3,10.5-13.7c4.1-1.5,8.4-1.8,12.7-1.9c4.1-0.1,8.2-0.1,12.3,0 c1.4,0,1.8-0.4,1.8-1.8c-0.1-5.5-4.1-9.7-9.9-10.3c-5-0.6-9.9-0.2-14.9-0.3c-2.3,0-4.5,0-6.8,0c-1.1,0-1.6-0.4-1.6-1.6 c0-2.7,0-5.4,0-8.1c0-0.9,0.3-1.4,1.4-1.4c8.7,0.2,17.4-0.6,26,0.4c7.7,0.9,14,4.3,17.3,11.9c1.1,2.5,1.7,5.1,1.9,7.8 c0,0.6,0,1.2,0.3,1.8C500,75.2,500,86.7,500,98.1z M486.4,78.3c0-0.7,0-1.1,0-1.6c0-2.3,0-2.3-2.3-2.3c-3.7,0-7.4,0-11.1,0 c-1.8,0-3.6,0.2-5.4,0.7c-3.3,0.9-5.2,3-5.4,5.9c-0.2,3.3,1.4,6,4.7,7.1c5.1,1.8,10,1.3,14.6-1.5C484.8,84.7,486.9,82,486.4,78.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.7,48.4c0.8,0,1.1-0.5,1.4-0.8c7.9-7.2,22.6-7.8,31.1-1.3c1.2,0.9,2.4,2,3.2,3.3c0.8,1.2,1.2,1,2.1,0.1 c8-8.7,22.8-9.7,31.4-5.3c5.1,2.6,8.3,6.7,9.9,12c0.9,3,1.3,6.1,1.3,9.3c0,10.1,0,20.3,0,30.4c0,2.1-0.1,2.2-2.1,2.2 c-3.1,0-6.2-0.1-9.3,0c-1.5,0-2-0.5-2-2c0.1-9.1,0-18.3,0-27.4c0-2.4-0.2-4.8-0.9-7.2c-1.3-4.5-4.2-7.1-8.8-7.9 c-8.6-1.5-15.7,3.9-16.7,12.6c-0.5,4.2-0.2,8.4-0.3,12.5c-0.1,5.7,0,11.5,0,17.2c0,2.2,0,2.2-2.2,2.2c-3,0-6-0.1-8.9,0 c-1.7,0.1-2.2-0.5-2.2-2.2c0.1-9.7,0-19.4,0-29.1c0-1.4-0.2-2.9-0.5-4.3c-1.7-7.5-7.3-10.2-14.9-8.9c-6.7,1.2-10.9,6.4-11,13.7 c-0.1,9.3-0.1,18.6-0.1,27.9c0,2.8,0,2.8-2.7,2.8c-2.8,0-5.6,0-8.4,0c-2.4,0-2.4,0-2.4-2.4c0-17,0-33.9,0-50.9c0-0.2,0-0.4,0-0.7 c-0.1-1.2,0.4-1.8,1.7-1.8c3.1,0.1,6.3,0.1,9.4,0c1.4,0,1.9,0.6,1.8,1.9C285.6,45.7,285.7,47.1,285.7,48.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.7,48.8c3.6-3.3,7.3-5.5,11.7-6.4c18-3.4,34,7.7,34.3,27.1c0.1,8.3-2.2,15.8-8.3,21.7 c-4.7,4.7-10.5,7-17.1,7.5c-5.4,0.4-10.7-0.2-15.6-2.8c-2-1.1-3.7-2.6-5.5-4.2c-0.5,1.5-0.3,2.9-0.2,4.3c0.1,1.5-0.4,2.2-2,2.1 c-2.9-0.1-5.7-0.1-8.6,0c-1.6,0.1-2.1-0.5-2.1-2.1c0.1-10.5,0-20.9,0-31.4c0-13.9,0-27.7,0-41.6c0-2.3,0-2.3,2.3-2.3 c3,0,6.1,0.1,9.1,0c1.5,0,2,0.5,2,2c-0.1,7.9,0,15.9,0,23.8C395.7,47.2,395.7,47.7,395.7,48.8z M395.7,70.2c0,0.8-0.1,1.5,0,2.3 c0.7,6.6,3.8,11.6,10.1,13.9c6.3,2.3,12.3,1.5,17.4-3.3c4.2-3.9,5.1-8.9,4.9-14.3c-0.3-10-9.1-17.1-19-15.3 C400.7,54.9,395.7,61.2,395.7,70.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.8,119.3c2.9-0.9,5.3-1.6,7.8-2.3c20.7-6.1,41.3-12.4,61.8-19c14.4-4.7,28.8-9.6,43-14.8 c0.6-0.2,1.2-0.7,1.7-0.3c0.6,0.5,0,1.3-0.2,1.8c-9.4,24.4-27,38.7-53.1,42.3c-12.6,1.7-24.7-0.7-36.1-6.4 c-0.9-0.5-1.9-0.5-2.9-0.5c-6.6-0.1-13.2-0.2-19.9-0.3C11.5,119.7,10.8,119.8,9.8,119.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194,86.3c0.6,0.4,1.2,0.2,1.8,0.2c9.5,0,19,0,28.5,0c1.6,0,2.3,0.4,2.2,2.1c-0.1,2.4,0,4.7,0,7.1 c0,2.5,0,2.5-2.4,2.5c-13,0-26.1,0-39.1,0c-2.7,0-5.4,0-8.1,0c-1.3,0-1.8-0.4-1.8-1.7c0.1-2.1,0.1-4.2,0-6.3c0-1.1,0.5-1.9,1.2-2.6 c5.8-6.7,11.5-13.3,17.3-20c3.6-4.2,7.2-8.3,10.8-12.5c0.3-0.4,0.9-0.7,0.7-1.2c-0.2-0.5-0.9-0.3-1.4-0.3c-8.6,0-17.2,0-25.8,0 c-2.4,0-2.4,0-2.4-2.5c0-2.5,0-5,0-7.4c0-1.2,0.4-1.8,1.7-1.8c15.1,0,30.2,0,45.4,0c1.2,0,1.7,0.4,1.7,1.6c-0.1,2.1,0,4.3,0,6.4 c0,1-0.4,1.7-1,2.4c-9.3,10.7-18.6,21.5-27.9,32.2C194.8,85.1,194.2,85.5,194,86.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.2,70.4c0,8.5,0,17.1,0,25.6c0,2.1-0.1,2.2-2.3,2.2c-2.9,0-5.8,0-8.8,0c-2.3,0-2.3,0-2.3-2.3 c0-13.8,0-27.5,0-41.3c0-3.4,0.1-6.8,0-10.2c0-1.5,0.5-1.9,1.9-1.9c3.2,0.1,6.4,0.1,9.6,0c1.5,0,1.9,0.6,1.9,2 C256.2,53.1,256.2,61.8,256.2,70.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.2,28.2c0-4,3.3-7.3,7.2-7.3c4.1,0,7.5,3.4,7.5,7.4c0,4-3.5,7.4-7.4,7.3C245.4,35.5,242.2,32.2,242.2,28.2 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.6c5ed7baec67120b5fcf8242566f2ce4.svg";
export { ForwardRef as ReactComponent };